import * as skillNames from "./skillNames";

const defaultStack = [
  skillNames.HTML,
  skillNames.CSS,
  skillNames.JavaScript,
  skillNames.Git,
];

//  bought bootcamp course on Feb. 13, 2018
export const experienceDateStartJs = "01/05/2018";

export const projects = [
  {
    name: "This portfolio",
    description: ``,
    extraInfo: "",
    githubLink: "",
    appLink: window.location.host,
    skills: [...defaultStack, skillNames.ReactJs, skillNames.SASS],
    dateProjectStarted: "01/02/2020",
  },
  {
    name: "Tooth Protect",
    description: `MEAN (Mongo, Express, Angular , NodeJs) Application. This application simulates a Dentist Web Page. There you can:
        Login/Register
        See a short description of doctors
        Make an appointment
        Download form`,
    extraInfo: "",
    githubLink: "https://github.com/gfx96/tooth-protect?",
    appLink: "https://tooth-protect.herokuapp.com/home",
    skills: [
      ...defaultStack,
      skillNames.Angular,
      skillNames.Heroku_hosting,
      skillNames.NodeJS,
      skillNames.CleanCode,
    ],
    dateProjectStarted: "01/02/2019",
  },
  {
    name: "Recipe book",
    description: `Here you can see my first complex application made with Angular framework. 
      You can register/login , and save/edit/delete ingredients of yours desired recipes`,
    extraInfo: "",
    githubLink: "https://github.com/gfx96/Recipe-Book?",
    appLink: "https://warm-harbor-25252.herokuapp.com/",
    skills: [
      ...defaultStack,
      skillNames.Angular,
      skillNames.TypeScript,
      skillNames.Heroku_hosting,
      skillNames.Firebase_DB_andnotifications,
      skillNames.CleanCode,
    ],
    dateProjectStarted: "20/09/2018",
  },
  {
    name: "FreeBook - Facebook clone",
    description: `Mini facebook clone, into app you can: add or delete simple and images posts; 
    Like - unlike
    Comments
    Register/Login
    Approach to Facebook original design
    Be aware, there can be major bugs regarding UI and logic, this were ones of my projects where I
    learned NodeJs.
    `,
    extraInfo: "",
    githubLink: "https://github.com/gfx96/facebook_clone?",
    appLink: "https://morning-hollows-63838.herokuapp.com/register&login",
    skills: [
      ...defaultStack,
      skillNames.jQuery,
      skillNames.NodeJS,
      skillNames.Heroku_hosting,
    ],
    dateProjectStarted: "26/07/2018",
  },
  {
    name: "Campgrounds",
    description: `That's my first complex website that I made on web development courses. After making an account, you can add a campground , a price, edit it , delete it and receive comments from other users.`,
    extraInfo: "",
    githubLink: "https://github.com/gfx96/CampGrounds?",
    appLink: "https://arcane-headland-85364.herokuapp.com/",
    skills: [
      ...defaultStack,
      skillNames.jQuery,
      skillNames.NodeJS,
      skillNames.Heroku_hosting,
      skillNames.CleanCode,
    ],
    dateProjectStarted: "15/09/2018",
  },
  {
    name: "Fast agenda",
    description: `An application made after my idea. Login is made with Google account, user being capable of saving data directly on Google Calendars. 
      You also can save/delete/check/un-check Tasks, ordered by week. Here I learned to use BEM methodology.
      Also, all the interactions with the storage (offline support) is made by me.
      `,
    extraInfo: "",
    githubLink: "https://github.com/gfx96/fastAgenda-v2?",
    appLink: "https://fastagenda-1cdc8.firebaseapp.com/toDoWeek",
    skills: [
      skillNames.HTML,
      skillNames.SASS,
      skillNames.Angular,
      skillNames.TypeScript,
      skillNames.Firebase_DB_andnotifications,
      skillNames.CleanCode,
    ],
    importance: 1,
    dateProjectStarted: "25/01/2019",
  },
  {
    name: "Todo list",
    description:
      "This project is a simple to do list, which have a nice design, but no database or any responsive design.",
    extraInfo: "",
    githubLink: "https://github.com/gfx96/To-Do-List?",
    appLink: "http://vasilache-andrei.herokuapp.com/todo",
    skills: [...defaultStack, skillNames.jQuery],
    dateProjectStarted: "15/09/2018",
  },
  {
    name: "Trivia game",
    description: `In this project I tried to perfect my code writing skills, 
    using concepts like DRY(Do not repeat yourself!),KISS(Keep it simple,stupid), 
    YAGNI(You aren't gonna need it!).`,
    extraInfo: "",
    githubLink: "https://github.com/gfx96/Trivia-Game?",
    appLink: "http://vasilache-andrei.herokuapp.com/triviador",
    skills: [...defaultStack, skillNames.CleanCode],
    dateProjectStarted: "21/12/2018",
  },
  {
    name: "HomeWally",
    description: `That's the project that I use and love the most.
    You can use it as a browser homepage. Features:

    Use your own background images.
    Use which link you want (On buttons).
    Choose which name you want.
    Get the weather on your wanted location (just romanian cities).`,
    extraInfo: "",
    githubLink: "https://github.com/gfx96/gfx96.github.io?",
    appLink: "https://gfx96.github.io/",
    skills: [...defaultStack, skillNames.jQuery],
    dateProjectStarted: "03/06/2018",
  },
  {
    name: "Color guess",
    description: `That project is based on RGB system of colors.
    There you need to guess which one is the right color.`,
    extraInfo: "",
    githubLink: "https://github.com/gfx96/GuessTheColor?",
    appLink: "http://vasilache-andrei.herokuapp.com/guess",
    skills: [...defaultStack, skillNames.jQuery],
    dateProjectStarted: "15/09/2018",
  },
  {
    name: "Tic tac toe",
    description: `This game was done after the traditional Tic-Tac-Toe concept and rules.
     For the columns and rows I used a 3 x 3 matrix, 
     and a function that checks if squares are filled with X or 0's (Short explanation of project , 
      there are more than one function... ._. )`,
    extraInfo: "",
    githubLink: "https://github.com/gfx96/Tic-Tac-Toe?",
    appLink: "http://vasilache-andrei.herokuapp.com/tic-tac-toe",
    skills: [...defaultStack, skillNames.jQuery, skillNames.CleanCode],
    dateProjectStarted: "29/06/2018",
  },
  {
    name: "Snake",
    description: `This game was made after the old-style and simplest snake ever made.
    For this I used an array witch stores the x and y values of snake head and tail. 
    On snake movement we are incrasing this values. 
    Be aware, on this project you can find some bugs.`,
    extraInfo: "",
    githubLink: "https://github.com/gfx96/Snake?",
    appLink: "http://vasilache-andrei.herokuapp.com/snake",
    skills: [...defaultStack, skillNames.jQuery],
    dateProjectStarted: "29/06/2018",
  },
  {
    name: "Game of life",
    description: `This is a project made after Game of life rules:
    Any live cell with fewer than two live neighbors dies, as if by under population.
    Any live cell with two or three live neighbors lives on to the next generation.
    Any live cell with more than three live neighbors dies, as if by overpopulation.
    Any dead cell with exactly three live neighbors becomes a live cell, as if by reproduction`,
    extraInfo: "",
    githubLink: "https://github.com/gfx96/GameOfLife?",
    appLink: "http://vasilache-andrei.herokuapp.com/gameOfLife",
    skills: [...defaultStack, skillNames.jQuery],
    dateProjectStarted: "30/08/2018",
  },
  // {
  //   name: "Flappy bird",
  //   description: `Flappy bird game, based on p5.`,
  //   extraInfo: "",
  //   githubLink: "https://github.com/gfx96/flappyBird",
  //   appLink: `${window.location.host}/projects/flappyBird`,
  //   skills: [...defaultStack, skillNames.p5, skillNames.CleanCode],
  //   dateProjectStarted: "01/12/2018",
  // },
];
